export default {
    en: {
        resumeAssuranceTitleAP: 'Loan Insurance',
        resumeAssuranceTitleAPMat: 'Loan Insurance – Versatile Line of Credit',

        resumeAssuranceAdmissibleSansChoix: 'No insurance',

        resumeAssuranceVieTitle: 'Life insurance',
        resumeAssuranceVieTexte: ' of mortgage balance',
        resumeAssuranceVieApMatTexte:
            ' of tied loan and Versatile Line of Credit balances',
        resumeAssuranceVieDisabledTexte:
            'No longer eligible. Will be over 70 at renewal',

        resumeAssuranceInvaliditeTitle: 'Disability insurance',
        resumeAssuranceInvaliditeTexte: ' of regular payment',
        resumeAssuranceInvaliditeRequisTexte: ' of required payment',
        resumeAssuranceInvaliditeDisabledTexte:
            'No longer eligible. Will be over 65 at renewal',
        resumeAssuranceTauxSupplementaire:
            'Additional insurance rate for the Versatile Line of Credit',
        resumeAssuranceTauxInteretAdditionnel: 'Additional insurance rate',
        resumeAssuranceTauxInteretAdditionnelMat:
            'Additional insurance rate for the tied loan',

        resumeChangeButton: 'Edit',
        modifierProtectionTexteHorsEcran: 'coverage',
        modifierProfilAssuranceTexteHorsEcran: 'profil',
        modifierQuestionnaireAssuranceTexteHorsEcran: 'answers to questions',

        comprendreAssuranceButton: 'Learn about insurance costs',

        tagDemandeAcceptee: 'Application accepted',
        profilTitre: 'Profile',
        profilSousTitreResidence: 'Canadian resident',
        profilInfoBulleResidence:
            'You are legally allowed to live in Canada, and you reside there for at least 6\xa0months each year.',
        profilInfoBulleResidenceTextHorsEcran: 'Canadian residency',
        profilSousTitreFumeur:
            'Tobacco and nicotine product usage in the past 12\xa0months',
        profilInfoBulleFumeur:
            'These products include: cigarettes, cigarillos, cigars, pipes, electronic cigarettes, nicotine gum or nicotine patches and anti-smoking medication.',
        profilInfoBulleFumeurTextHorsEcran:
            'tobacco and nicotine product usage in the past 12 months',

        questionnaireTitre: 'Questionnaire',

        indicateurOui: 'Yes',
        indicateurNon: 'No',
        protection: 'Coverage',
        protectionComplete: 'Full coverage',
        protectionIntermediaire: 'Intermediate coverage',
        protectionVieSeulement: 'Life insurance only'
    },
    fr: {
        resumeAssuranceTitleAP: 'Assurance prêt',
        resumeAssuranceTitleAPMat: 'Assurance prêt – marge Atout',

        resumeAssuranceAdmissibleSansChoix: 'Aucune assurance',

        resumeAssuranceVieTitle: 'Assurance vie',
        resumeAssuranceVieTexte: ' du solde du prêt',
        resumeAssuranceVieApMatTexte:
            ' du solde du prêt lié et de la marge Atout',
        resumeAssuranceVieDisabledTexte:
            'N’est plus admissible, car aura dépassé 70 ans au renouvellement',

        resumeAssuranceInvaliditeTitle: 'Assurance invalidité',
        resumeAssuranceInvaliditeTexte: ' du paiement régulier',
        resumeAssuranceInvaliditeRequisTexte: ' du paiement requis',
        resumeAssuranceInvaliditeDisabledTexte:
            'N’est plus admissible, car aura dépassé 65 ans au renouvellement',
        resumeAssuranceTauxSupplementaire:
            'Taux supplémentaire pour l’assurance de la marge Atout',
        resumeAssuranceTauxInteretAdditionnel:
            'Taux d’intérêt additionnel pour l’assurance',
        resumeAssuranceTauxInteretAdditionnelMat:
            'Taux d’intérêt additionnel pour l’assurance du prêt lié',

        resumeChangeButton: 'Modifier',
        modifierProtectionTexteHorsEcran: 'la protection',
        modifierProfilAssuranceTexteHorsEcran: 'le profil',
        modifierQuestionnaireAssuranceTexteHorsEcran:
            'les réponses au questionnaire',

        comprendreAssuranceButton: 'Comprendre le coût de l’assurance',
        tagDemandeAcceptee: 'Demande acceptée',

        profilTitre: 'Profil',
        profilSousTitreResidence: 'Résidence canadienne',
        profilInfoBulleResidence:
            'La loi vous autorise à demeurer au Canada et vous y résidez pendant au moins 6\xa0mois par année.',
        profilInfoBulleResidenceTextHorsEcran: 'la résidence canadienne',
        profilSousTitreFumeur:
            'Usage du tabac ou de produits de nicotine dans les 12\xa0derniers mois',
        profilInfoBulleFumeur:
            'Ces produits incluent\xa0: cigarette, cigarillo, cigare, pipe, cigarette électronique, gomme ou timbre de nicotine, et médicament pour cesser de fumer.',
        profilInfoBulleFumeurTextHorsEcran:
            'l’usage du tabac ou de produits de nicotine dans les 12 derniers mois',

        questionnaireTitre: 'Questionnaire',

        indicateurOui: 'Oui',
        indicateurNon: 'Non',
        protection: 'Protection',
        protectionComplete: 'Protection complète',
        protectionIntermediaire: 'Protection intermédiaire',
        protectionVieSeulement: 'Protection vie seulement'
    }
};
